import styled from 'styled-components';
import { View } from '../View/view';


export interface ColProps{

}
export const Col = styled(View)<ColProps>`
    flex:1
`;


